import * as React from 'react'

import { observer } from 'mobx-react'

const ExplotableList = (props: React.PropsWithChildren<Record<string, unknown>>) => {
  const { children } = props

  return <ul>{children}</ul>
}

export default observer(ExplotableList)
